import Italic from '@tiptap/extension-italic';

/**
 * Change the tag from <em> to <i>
 */
export default Italic.extend({
  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, any> }) {
    return ['i', HTMLAttributes];
  },

  parseHTML() {
    return [
      { tag: 'i' },
    ];
  },
});
